/*
 *
 * ManageApiKeyModal
 *
 * @version 1.0.0
 * @author Christopher Monti
 * @since 25-Mar-2025
 */

import { connect } from 'react-redux'
import { doPopup } from 'Store/actions/popup'
import ManageApiKeyModal from './ManageApiKeyModal'
import * as TerminalManagementActions from 'Route/TerminalsManagement/modules/TerminalsManagementActions'

const mapDispatchToProps = (dispatch) => ({
  doResetShowApiKeyResult: () => dispatch(TerminalManagementActions.doResetShowApiKeyResult()),
  closePopup: () => dispatch(doPopup('')),
  doShowApiKey: (nexiAccountId) => {
    dispatch(TerminalManagementActions.doShowApiKey(nexiAccountId))
  }
})

const mapStateToProps = (state) => ({
  data: state?.popup?.popupData || {},
  isLoading: state.loading?.local_terminalsManagementShowApiKey || false,
  showApiKeyResult: state.TerminalsManagement.showApiKeyResult || null,
  selectedTerminalId: state.TerminalsManagement.selectedTerminalId || null
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ManageApiKeyModal)
